import * as React from 'react';

// COMPONENTS
import Button from '../../components/Button';

// ICONS
import { ReactComponent as LinkIcon } from '../../assets/svg/link.svg';

// TYPES
import { DomainProfileType } from '../../api/models';

interface InviteItemTypes {
	role?: string;
	organisationIdentifier?: string;
}

const InviteItem: React.FC<InviteItemTypes> = ({ role, organisationIdentifier }) => {
	const displayRole = (role: string) => {
		if (role === DomainProfileType.Staff) {
			return (
				<>
					<h4 className="text">
						Invite a <strong>Staff or Volunteer</strong>{' '}
					</h4>

					<p className="info">
						Any person 18+ years of age, with an official role at the organisation, paid or unpaid.
					</p>
				</>
			);
		} else if (role === DomainProfileType.Parent) {
			return (
				<>
					<h4 className="text">
						Invite a <strong>Parent or Parent Volunteer</strong>{' '}
					</h4>

					<p className="info">Includes carers or guardians.</p>
				</>
			);
		} else if (role === DomainProfileType.Student) {
			return (
				<>
					<h4 className="text">
						Invite a <strong>Child or Student</strong>{' '}
					</h4>

					<p className="info">13yrs+ years of age, including children or youth working, volunteering or studying.</p>
				</>
			);
		} else if (role === DomainProfileType.Visitor) {
			return (
				<>
					<h4 className="text">
						Invite a <strong>Visitor</strong>{' '}
					</h4>

					<p className="info">Any other adult visiting the organisation</p>
				</>
			);
		} else {
			return (
				<h4 className="text">
					Invite a <strong>{role.substring(0, 1).toUpperCase() + role.substring(1)}</strong>
				</h4>
			);
		}
	};

	const [copySuccess, setCopySuccess] = React.useState<string>('');

	const copyToClipBoard = async (copiedText: string) => {
		try {
			await navigator.clipboard.writeText(window.location.origin + copiedText);
			setCopySuccess('Link Copied!');
			setTimeout(() => {
				setCopySuccess('');
			}, 3000);
		} catch (err) {
			setCopySuccess('Failed to copy!');
		}
	};

	return (
		<div className="invite-links-block">
			<div className="invite-text">{displayRole(role || '')}</div>

			<Button
				onClick={() =>
					copyToClipBoard(`/find-organisation?id=${organisationIdentifier}&type=${(role && role.toLowerCase()) || ''}`)
				}
				type="button"
				className="btn-secondary"
			>
				{copySuccess ? (
					<>{copySuccess}</>
				) : (
					<>
						<LinkIcon className="link-icon" />
						Copy link
					</>
				)}
			</Button>
		</div>
	);
};

export default InviteItem;
